import * as React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../../hooks';
import { selectUser } from '../../slices/global/authSlice';

export default function ProtectedRoute(props: { children?: any }) {
  const user = useAppSelector(selectUser);
  if (!user) {
    return <Navigate to="/" />;
  }

  return (
    <div>
      <nav>{props.children}</nav>
      <Outlet />
    </div>
  );
}
